import type { ContactMessageItem } from "@/lib/gql/__generated__/graphql";

import { FromNowText, MessageAndImages } from "../_components";

type Props = {
	message: ContactMessageItem;
};

export const HostMessage = ({ message }: Props) => {
	return (
		<div className="flex justify-end">
			<div className="flex w-1/2 flex-col gap-y-2">
				<div className="flex justify-end">
					<FromNowText createdAt={message.createdAt} />
				</div>
				<div className="rounded-b-xl rounded-tl-xl bg-brand/20 p-4">
					<MessageAndImages message={message.message} images={message.images} />
				</div>
			</div>
		</div>
	);
};

HostMessage.displayName = "HostMessage";
